/**
 * URL for GET api/manpowers/jobsworked/{HRRef}. includeStepUp adds the step-up hours and class; billableOnly drops
 * overhead jobs; stepUpByClass (US 36863, only with includeStepUp) returns one row per dispatch and step-up class
 * instead of one per dispatch, so each step-up class shows its own hours.
 */
export function jobsWorkedUrl(
  hrRef: string | number,
  includeStepUp = false,
  billableOnly = false,
  stepUpByClass = false
): string {
  const params: string[] = [];
  if (includeStepUp) params.push('includeStepUp=true');
  if (billableOnly) params.push('billableOnly=true');
  if (includeStepUp && stepUpByClass) params.push('stepUpByClass=true');
  const queryString = params.length > 0 ? `?${params.join('&')}` : '';
  return `/api/manpowers/jobsworked/${hrRef}${queryString}`;
}
